import { AxiosError } from "axios";

export const getPhoneLoginErrorDisplayMessage = (error: AxiosError) => {
  const statusCode = error?.response?.status;
  if (statusCode === 422) {
    return "Phone number is invalid";
  }
  if (statusCode === 401) {
    return "No user found with that phone number.";
  }

  return "There was an error logging in. Please try again later.";
};
